import React, { useRef } from 'react';
import { useReactToPrint } from 'react-to-print';
import { Bar, Line } from 'react-chartjs-2';
import { FaDatabase, FaExclamationTriangle } from 'react-icons/fa';
import dateformat from 'utils/dateformat';

import {
  Card,
  Container,
  Row,
  Col,
  Table,
  Button,
  Form as BootstrapForm
} from 'react-bootstrap';

const Form = (props) => {
  const {
    data,
    fieldChange,
    handleIdChange,
    selectedId,
  } = props;

  const componentRef = useRef();
  const handlePrint = useReactToPrint({
    content: () => componentRef.current
  });

  return (
    <Card className="shadow mb-4">
      <Card.Body>
        <BootstrapForm>
          <BootstrapForm.Select
            id="test-id-select"
            value={selectedId}
            onChange={handleIdChange}
            className="mb-3">
            {data.testIds
              ? data.testIds.map((item) => (
                <option key={item} value={item}>
                  {dateformat(new Date(item))}
                </option>
              ))
              : null}
          </BootstrapForm.Select>

          <div ref={componentRef}>
            <Card className="mb-4">
              <Card.Body>
                <h1 className="text-center mt-1 mb-4">LAUDO TÉCNICO DO EQUIPAMENTO</h1>

                <Table bordered size="sm" className="mb-4">
                  <thead>
                    <tr>
                      <th className="text-center">NÚMERO DE SÉRIE</th>
                      <th className="text-center">NÚMERO DE TESTES</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td className="text-center">{data.serialnumber}</td>
                      <td className="text-center">
                        {isNaN(data.numerrors + data.nummedicoes)
                          ? ''
                          : data.numerrors + data.nummedicoes}
                      </td>
                    </tr>
                  </tbody>
                </Table>
              </Card.Body>

              {data.numerrors + data.nummedicoes < 200 && (
                <h4 className="text-danger text-center mb-3">
                  Ainda faltam {200 - (data.numerrors + data.nummedicoes)}{' '}
                  testes para geração do laudo do equipamento.
                </h4>
              )}

              {data.numerrors + data.nummedicoes >= 200 && (
                <Card.Body>
                  <Table bordered size="sm" className="mb-4">
                    <thead>
                      <tr>
                        <th className="text-center" colSpan="7">
                          ANÁLISE DOS COMPONENTES
                        </th>
                      </tr>
                      <tr>
                        <th className="text-center">COMPONENTE</th>
                        <th className="text-center">FALHAS</th>
                        <th className="text-center">%</th>
                        <th className="text-center">OK (%)</th>
                        <th className="text-center">ALERTA (%)</th>
                        <th className="text-center">FALHA (%)</th>
                        <th className="text-center">RESULTADO</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td className="text-start">Célula de carga</td>
                        <td className="text-center">{data.errosCelCarga}</td>
                        <td className="text-center">{data.errosCelCargaPercent}</td>
                        <td className="text-center">&lt;1</td>
                        <td className="text-center">1 a 2</td>
                        <td className="text-center">&gt;2</td>
                        <td className="text-center">
                          {data.errosCelCargaPercent < 1
                            ? 'OK'
                            : data.errosCelCargaPercent < 2
                              ? 'ALERTA'
                              : 'FALHA'}
                        </td>
                      </tr>
                      <tr>
                        <td className="text-start">Posição do copo de medicão</td>
                        <td className="text-center">{data.errosCupMed}</td>
                        <td className="text-center">{data.errosCupMedPercent}</td>
                        <td className="text-center">&lt;2</td>
                        <td className="text-center">2 a 5</td>
                        <td className="text-center">&gt;5</td>
                        <td className="text-center">
                          {data.errosCupMedPercent < 2
                            ? 'OK'
                            : data.errosCupMedPercent < 5
                              ? 'ALERTA'
                              : 'FALHA'}
                        </td>
                      </tr>
                      <tr>
                        <td className="text-start">Servo motor</td>
                        <td className="text-center">{data.errosSM}</td>
                        <td className="text-center">{data.errosSMPercent}</td>
                        <td className="text-center">&lt;2</td>
                        <td className="text-center">2 a 5</td>
                        <td className="text-center">&gt;5</td>
                        <td className="text-center">
                          {data.errosSMPercent < 2
                            ? 'OK'
                            : data.errosSMPercent < 5
                              ? 'ALERTA'
                              : 'FALHA'}
                        </td>
                      </tr>
                      <tr>
                        <td className="text-start">Borboleta</td>
                        <td className="text-center">{data.errosBorb}</td>
                        <td className="text-center">{data.errosBorbPercent}</td>
                        <td className="text-center">&lt;2</td>
                        <td className="text-center">2 a 5</td>
                        <td className="text-center">&gt;5</td>
                        <td className="text-center">
                          {data.errosBorbPercent < 2
                            ? 'OK'
                            : data.errosBorbPercent < 5
                              ? 'ALERTA'
                              : 'FALHA'}
                        </td>
                      </tr>
                      <tr>
                        <td className="text-start">Cabo flat osciladora</td>
                        <td className="text-center">{data.errosCabFlat}</td>
                        <td className="text-center">{data.errosCabFlatPercent}</td>
                        <td className="text-center">&lt;0</td>
                        <td className="text-center">&lt;0.5</td>
                        <td className="text-center">&gt;0.5</td>
                        <td className="text-center">
                          {data.errosCabFlatPercent <= 0 ? 'OK' : 'FALHA'}
                        </td>
                      </tr>
                      <tr>
                        <td className="text-start">Osciladora</td>
                        <td className="text-center">{data.errosOsc}</td>
                        <td className="text-center">{data.errosOscPercent}</td>
                        <td className="text-center">&lt;1</td>
                        <td className="text-center">1 a 2</td>
                        <td className="text-center">&gt;2</td>
                        <td className="text-center">
                          {data.errosOscPercent < 1
                            ? 'OK'
                            : data.errosOscPercent < 2
                              ? 'ALERTA'
                              : 'FALHA'}
                        </td>
                      </tr>
                      <tr>
                        <td className="text-start">Sensor de Temperatura</td>
                        <td className="text-center">{data.errosTemp}</td>
                        <td className="text-center">{data.errosTempPercent}</td>
                        <td className="text-center">&lt;1.5</td>
                        <td className="text-center">1.5 a 3</td>
                        <td className="text-center">&gt;3</td>
                        <td className="text-center">
                          {data.errosTempPercent < 2
                            ? 'OK'
                            : data.errosTempPercent < 3
                              ? 'ALERTA'
                              : 'FALHA'}
                        </td>
                      </tr>
                      <tr>
                        <td className="text-start">Tampa do Funil</td>
                        <td className="text-center">{data.errosTampFun}</td>
                        <td className="text-center">{data.errosTampFunPercent}</td>
                        <td className="text-center">&lt;2</td>
                        <td className="text-center">2 a 5</td>
                        <td className="text-center">&gt;5</td>
                        <td className="text-center">
                          {data.errosTampFunPercent < 2
                            ? 'OK'
                            : data.errosTampFunPercent < 5
                              ? 'ALERTA'
                              : 'FALHA'}
                        </td>
                      </tr>
                      <tr>
                        <td className="text-start">SOMA DAS FALHAS</td>
                        <td className="text-center">{data.sumFail}</td>
                        <td className="text-center">{data.sumFailPercent}</td>
                        <td className="text-center">&lt;12</td>
                        <td className="text-center">12 a 15</td>
                        <td className="text-center">&gt;15</td>
                        <td className="text-center">
                          {data.sumFailPercent < 12
                            ? 'OK'
                            : data.sumFailPercent < 15
                              ? 'ALERTA'
                              : 'FALHA'}
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </Card.Body>
              )}
              {data.numerrors + data.nummedicoes >= 200 && (
                <Card.Body>
                  <Table bordered size="sm" className="mb-4">
                    <thead>
                      <tr>
                        <th className="text-center">RESULTADO</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td
                          className={`text-center ${data.errosCelCargaPercent > 2 ||
                              data.errosCupMedPercent > 5 ||
                              data.errosSMPercent > 5 ||
                              data.errosBorbPercent > 5 ||
                              data.errosCabFlatPercent > 0 ||
                              data.errosOscPercent > 2 ||
                              data.errosTempPercent > 3 ||
                              data.errosTampFunPercent > 5 ||
                              data.sumFailPercent > 15
                              ? 'bg-danger text-white p-3'
                              : 'bg-success text-white p-3'
                            }`}>
                          {data.errosCelCargaPercent > 2 ||
                            data.errosCupMedPercent > 5 ||
                            data.errosSMPercent > 5 ||
                            data.errosBorbPercent > 5 ||
                            data.errosCabFlatPercent > 0 ||
                            data.errosOscPercent > 2 ||
                            data.errosTempPercent > 3 ||
                            data.errosTampFunPercent > 5 ||
                            data.sumFailPercent > 15
                            ? 'REPROVADO'
                            : 'APROVADO'}
                        </td>
                      </tr>
                    </tbody>
                  </Table>
                </Card.Body>
              )}
            </Card>
          </div>

          <Card.Footer className="d-flex justify-content-start">
            <Button
              variant="primary"
              onClick={handlePrint}
              className="mb-3">
              Imprimir
            </Button>
          </Card.Footer>

          <hr className="my-4" />

          <Container className="mt-4">
            <Row className="justify-content-center">
              <Col md={5}>
                <Card className="text-center mb-3 p-3">
                  <Card.Body>
                    <FaDatabase size={30} className="text-primary mb-2" />
                    <h1>{data.nummedicoes ? data.nummedicoes : ""}</h1>
                    <p className="text-muted fs-5">Medições</p>
                  </Card.Body>
                </Card>
              </Col>

              <Col md={5}>
                <Card className="text-center mb-3 p-3">
                  <Card.Body>
                    <FaExclamationTriangle size={30} className="text-danger mb-2" />
                    <h1>{data.numerrors}</h1>
                    <p className="text-muted fs-5">Erros</p>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
          </Container>

          <div className="my-4">
            <Line data={data.umidade} options={data.optionsUmidade} />
          </div>

          <div className="my-4">
            <Line data={data.temperatura} options={data.optionsTemperatura} />
          </div>

          <div className="my-4">
            <Line data={data.peso} options={data.optionsPeso} />
          </div>

          <div className="my-4">
            <Line data={data.freqv} options={data.optionsFreqv} />
          </div>

          <div className="my-4">
            <Line data={data.freqc} options={data.optionsFreqc} />
          </div>

          <div className="my-4">
            <Line data={data.global} options={data.optionsGlobal} />
          </div>

          {data.erros && (
            <div className="my-4">
              <Bar
                data={data.erros}
                options={{
                  plugins: {
                    title: {
                      display: true,
                      text: 'Erros',
                      font: {
                        size: 20
                      }
                    },
                    legend: {
                      display: true,
                      position: 'right'
                    }
                  },
                  scales: {
                    y: {
                      min: 0,
                      ticks: {
                        stepSize: 1
                      }
                    }
                  }
                }}
              />
            </div>
          )}
        </BootstrapForm>
      </Card.Body>
    </Card>
  );
};

export default Form;
